import { readonly, ref } from "vue";

/**
 * Kurze Rueckmeldungen am unteren Bildschirmrand (Fehler beim Kommando, Erfolg).
 * Ersetzt die alert()-Boxen des alten Dashboards.
 */

export type ToastKind = "info" | "error";

export interface Toast {
  id: number;
  kind: ToastKind;
  text: string;
}

const toasts = ref<Toast[]>([]);
let nextId = 1;

function push(kind: ToastKind, text: string, holdMs: number): void {
  const id = nextId++;
  toasts.value = [...toasts.value, { id, kind, text }];
  window.setTimeout(() => dismiss(id), holdMs);
}

export function dismiss(id: number): void {
  toasts.value = toasts.value.filter((toast) => toast.id !== id);
}

export function useToasts() {
  return {
    toasts: readonly(toasts),
    info: (text: string) => push("info", text, 4000),
    error: (text: string) => push("error", text, 8000),
    dismiss,
  };
}
